/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowExtractedDtoSchema = z.object({
  industry: z.string().nullish(),
  businessModel: z.string().nullish(),
  stage: z.string().nullish(),
  country: z.string().nullish(),
});
